define('OutSystems/ReactWidgets/RadioButton',["require", "exports", "tslib", "OutSystems/ClientRuntime/DataConversion", "OutSystems/ClientRuntime/DataTypes", "OutSystems/ClientRuntime/Settings", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, DataConversion_1, DataTypes_1, Settings_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RadioButton = void 0;
    var RadioButton = (function (_super) {
        tslib_1.__extends(RadioButton, _super);
        function RadioButton() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        RadioButton.prototype.handleClick = function () {
            var _this = this;
            this.executeWithActiveClassOn(function () { return _this.props.updateValueInParent(_this.props.value); });
        };
        RadioButton.prototype.render = function () {
            var _this = this;
            var radioButtonInputId = this.getId() + "-input";
            var radioButtonDivAttributes = {
                "data-radio-button": "",
            };
            var radioButtonInputAttributes = tslib_1.__assign({ type: "radio", id: radioButtonInputId, className: this.props.style, name: this.props.groupName, value: DataConversion_1.JSConversions.convertTo(this.props.value, DataTypes_1.DataTypes.Text), hidden: !this.props.visible, disabled: !this.props.enabled, checked: this.props.isSelected, onChange: function () { return _this.handleClick(); } }, ((0, Settings_1.getEnvParams)().EnableWCAG22 && { "data-wcag22": "" }));
            var radioButtonLabelAttributes = {
                htmlFor: radioButtonInputId,
            };
            this.fillWithBuiltinProperties(radioButtonDivAttributes);
            return (React.createElement("div", tslib_1.__assign({}, radioButtonDivAttributes),
                React.createElement("input", tslib_1.__assign({}, radioButtonInputAttributes)),
                React.createElement("label", tslib_1.__assign({}, radioButtonLabelAttributes), this.props.children)));
        };
        RadioButton = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], RadioButton);
        return RadioButton;
    }(Widget_1.Widget));
    exports.RadioButton = RadioButton;
});
//# sourceMappingURL=RadioButton.js.map;
